import { Component, EventEmitter, Input, Output, HostListener } from '@angular/core';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { NgClass, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'top-bar-hamburger',
  templateUrl: './top-bar-hamburger.component.html',
  styleUrls: ['./top-bar-hamburger.component.css'],
  animations: [
    trigger('transitionOpen', [
      state(
        'open',
        style({
          transform: 'scaleY(1)',
          width: '125px',
        }),
      ),
      state(
        'closed',
        style({
          transform: 'scaleY(0)',
          display: 'none',
          width: '0px',
        }),
      ),
      transition('open => closed', [animate('.1s')]),
      transition('closed => open', [animate('.1s')]),
    ]),
    trigger('transitionExpand', [
      state(
        'expanded',
        style({
          width: '129px',
        }),
      ),
      state(
        'normal',
        style({
          width: '47px',
        }),
      ),
      transition('expanded => normal', [animate('.1s')]),
      transition('normal => expanded', [animate('.1s')]),
    ]),
  ],
  imports: [NgClass, NgStyle, RouterLink],
})
export class TopBarHamburgerComponent {
  @Input() showManagements!: boolean;
  @Input() logginButtonText!: string;
  @Input() loggedIn!: boolean;
  @Output() logOutEmitter = new EventEmitter<void>();
  @Output() createNew = new EventEmitter<void>();

  @HostListener('window.focus', ['this.toggleDropdown()'])
  closed = true;

  private debounceTimer?: NodeJS.Timeout;
  private lastEventType: 'enter' | 'leave' | null = null;
  private debounceDelay = 100; // milliseconds

  ngOnInit() {}

  public toggleDropdown(): void {
    this.closed = !this.closed;
  }

  public dropDownDisplay(): string {
    if (this.closed) {
      return 'none';
    } else {
      return 'flex';
    }
  }

  public logout(): void {
    this.logOutEmitter.emit();
    this.toggleDropdown();
  }

  onMouseEnter(): void {
    if (!this.closed) {
      // Clear any pending debounce
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = undefined;
      }

      this.lastEventType = 'enter';
      this.closed = false;
    }
  }

  onMouseLeave(): void {
    this.lastEventType = 'leave';

    // Only debounce if we're not already debouncing
    if (!this.debounceTimer) {
      this.debounceTimer = setTimeout(() => {
        // Only close if the last event was still mouseleave
        if (this.lastEventType === 'leave') {
          this.closed = true;
        }
        this.debounceTimer = undefined;
      }, this.debounceDelay);
    }
  }

  ngOnDestroy(): void {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }
}
